import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {ApiService} from './api.service';
import {WindowRefService} from './../window-ref.service';

const routes = {
    urlBase: '/manager',
};

@Injectable({
    providedIn: 'root'
})
export class ManagerService {

    constructor(private apiService: ApiService, private winRef: WindowRefService) {}
    loadDataList() {
        return this.apiService.get('/../'.concat(this.winRef.appConfigSite.defaultlangue, routes.urlBase,'/list'))
            .pipe(map((response: any) => {
                return response;
            }));
    }
    loadDataReservation(resaAuth: string) {
        return this.apiService.get('/../'.concat(this.winRef.appConfigSite.defaultlangue, routes.urlBase,'/reservation/', resaAuth))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    deleteRoom(resaAuth, idResEx) {
        let params = {resaAuth: resaAuth, idResEx: idResEx,idetab:this.winRef.appConfigSite.idEtab};
        return this.apiService.post('/../'.concat(this.winRef.appConfigSite.defaultlangue, routes.urlBase,'/delete-room'), params)
            .pipe(map((response: any) => {
                return response;
            }));
    }

    deleteResa(params: {resaAuth: string, description: string, motif: string}) {
        let _paramas = {annulation: params,idetab:this.winRef.appConfigSite.idEtab};
        return this.apiService.post('/../'.concat(this.winRef.appConfigSite.defaultlangue, routes.urlBase,'/delete-resa'), _paramas)
            .pipe(map((response: any) => {
                return response;
            }));
    }
}
